import _ from 'lodash'
import $ from 'jquery'
import Backbone from 'backbone'
import i18n from 'scoreboard/components/i18n'
import escapePreserveLineBreaks from 'scoreboard/components/escape-preserve-line-breaks'
import LoadingDots from 'scoreboard/components/loading-dots'
import DisplayHeader from 'scoreboard/components/display-header'
import mobile from 'scoreboard/components/mobile'
import selects from 'scoreboard/components/selects'
import template from './admin-logs.hbs'
import Xhr from 'scoreboard/components/xhr'

var AdminLogs = Backbone.View.extend({

    className: 'admin table-hack display-layout admin-logs-view',

	events: {
		'change .log-list': '_changeLogFile',
		'click .log-download': '_downloadFile'
	},

	initialize: function (options) {
		this.options = options || {}
		this.logNames = this.options.logs
		this.viewable = this.logNames
		this.on('resize', this.resizeLogBodyContainer)
	},

	render: function() {
		// Append the header (for mobile) and template content
		this.$el.empty().append(new DisplayHeader({
			heading: i18n.get('admin.viewLogs'),
			mobileGearHidden: true
		}).render().el, template())

		this.dots = new LoadingDots({ el: this.$('.loading-dots-container') })
		var options = _.map(this.viewable, function(name) {
			return { label: name, value: name }
		})
		selects.filtering(this.$('.log-list'), {
			options: options,
			sort: []
		})
		this.$('.log-download').prop('disabled', true)
		return this
	},

	remove: function() {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.dots], 'remove')
	},

	// Private Functions
	_changeLogFile: function(e) {
    	var filteringSelectIndex = e.target.selectedIndex - 1
		this.logName = this.viewable[filteringSelectIndex]
		this.logSelected = !_.isEmpty(this.logName)

		this.$('.log-download').prop('disabled', !this.logSelected)
		this.$('.banner').toggleClass('is-not-displayed', this.logSelected)
		this.$('.log-body-container').toggleClass('is-not-displayed', !this.logSelected)

		// Nix the old log file content
		this.$('.log-body').empty()

		if (this.logSelected) {
			this.dots.render()
			this.$('.log-body-container').removeAttr('style')
			// When the log html is inserted
			$.get('api/admin/logs/'+this.logName, function(content) {
				this.resizeLogBodyContainer()
				this._insertLogContentsInDOM(this.logName, content, this.$('.log-body'))
				// Nix loading dots
				this.dots.clear()
			}.bind(this))
		}
	},

	/**
	 * Insert the log into the DOM and properly format it.
	 * Because we are using an iframe, we cannot set styles in our css, therefore
	 * we're adding them here.
	 *
	 * @param logName i.e. output.log.html.1
	 * @param content The log content (html or text)
	 * @param logContainer Where the logs should be appended
	 * @private
	 */
	_insertLogContentsInDOM: function (logName, content, logContainer) {
		var htmlData = this._prepareHTML(logName, content)
		var htmlFormat = htmlData.htmlFormat
		var html = htmlData.html

		// Inject the styles into the iframe
		logContainer.removeAttr('style') // Remove inline styles when switching between logs
					.append(html)

		// If the inserted html doesn't need all the height it was given, adjust it
		if (logContainer.height() < logContainer.parent().height) {
			this.adjustedContentHeight = logContainer.height()
			logContainer.parent().height(this.adjustedContentHeight)
		}

		// Specific styles for txt logs
		if (!htmlFormat) {
			logContainer.css({
				'font-family': 'Monaco',
				'color': '#474B57',
				'font-size': '10px',
				'line-height': '2',
				'margin-top': '12px'
			})
			logContainer.find('pre')
				.css('margin', 0)
		} else {
			// If we're dealing with an html log, nix the style included in its
			// markup. The styling is handled in admin.logs
			logContainer.find('style').remove()
		}
	},

	/**
	 * Ensures the log contents is in the right format for displaying in the DOM
	 * @private
	 */
	_prepareHTML: function (logName, content) {
		var htmlFormat = _.includes(logName, '.html')
		var html = htmlFormat
			? content
			: '<pre>' + escapePreserveLineBreaks(content) + '</pre>'
		return {htmlFormat: htmlFormat, html: html}
	},

	_downloadFile: function() {
		if (!_.isEmpty(this.logName)) {
			new Xhr().download({
				url: 'api/admin/logs/' + this.logName
			})
		}
	},

	// Resize the .log-body-container so that it fits properly inside the .display-pane
	resizeLogBodyContainer: function() {
		var availableWidth = $('.display-pane').width()
		var availableHeight = $('.display-pane').height()
		// Here's our adjustment for the header+margin+other panel parts on the screen
		var heightAdjustment = mobile.isMobileOrientation() ? 201 : 148
		this.$el.width(availableWidth)
		this.$('.log-body-container').css({
			'width': availableWidth - 42, // 42 = margin + borders
			'height': (this.adjustedContentHeight || availableHeight) - heightAdjustment
		})
	}
})

export default AdminLogs

AdminLogs.__filename__ = 'admin/logs/admin-logs.js'
